var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 3.20971H3.08333C2.5308 3.20971 2.00089 3.4292 1.61019 3.8199C1.21949 4.2106 1 4.74051 1 5.29304V19.8764C1 20.4289 1.21949 20.9588 1.61019 21.3495C2.00089 21.7402 2.5308 21.9597 3.08333 21.9597H17.6667C18.2192 21.9597 18.7491 21.7402 19.1398 21.3495C19.5305 20.9588 19.75 20.4289 19.75 19.8764V12.5847M18.1875 1.64721C18.6019 1.23281 19.1639 1 19.75 1C20.3361 1 20.8981 1.23281 21.3125 1.64721C21.7269 2.06161 21.9597 2.62366 21.9597 3.20971C21.9597 3.79576 21.7269 4.35781 21.3125 4.77221L11.4167 14.668L7.25 15.7097L8.29167 11.543L18.1875 1.64721Z",
    stroke: "#6A6969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.41ba7ca325ab53d2ddb51bd571635efc.svg";
export { ForwardRef as ReactComponent };